/*
 * TRY ADD REQUIRED PERMISSIONS
 */

import { EFeaturesCategory } from '@/pages/+settings/workspace/features_access/table_base/EFeaturesCategory';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';

export function try_add_required_permissions(feature: string, permitted_features: string[]) {
  permitted_features = try_add_required_permission_collection_view(feature, permitted_features);
  permitted_features = try_add_required_permission_user_task_view(feature, permitted_features);
  permitted_features = try_add_required_permission_search_view(feature, permitted_features);
  permitted_features = try_add_required_permission_diffusion_models_rent_view(feature, permitted_features);

  return permitted_features;
}

function try_add_required_permission_collection_view(feature: string, permitted_features: string[]) {
  if (permitted_features.includes(ENUM__workspace_entity_feature.ENTITY_COLLECTION_VIEW)) return permitted_features;
  if (!feature.includes('COLLECTION')) return permitted_features;
  if (feature == ENUM__workspace_entity_feature.ENTITY_COLLECTION_VIEW) return permitted_features; //adding now

  return [...permitted_features, ENUM__workspace_entity_feature.ENTITY_COLLECTION_VIEW];
}

function try_add_required_permission_user_task_view(feature: string, permitted_features: string[]) {
  if (permitted_features.includes(ENUM__workspace_entity_feature.ENTITY_USER_TASK_VIEW)) return permitted_features;
  if (!feature.includes('USER_TASK') && !feature.includes('GENERATION')) return permitted_features;
  if (feature == ENUM__workspace_entity_feature.ENTITY_USER_TASK_VIEW) return permitted_features; //adding now

  return [...permitted_features, ENUM__workspace_entity_feature.ENTITY_USER_TASK_VIEW];
}

function try_add_required_permission_search_view(feature: string, permitted_features: string[]) {
  if (permitted_features.includes(ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW)) return permitted_features;
  if (!feature.includes('SEARCH')) return permitted_features;
  if (feature == ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW) return permitted_features; //adding now

  return [...permitted_features, ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW];
}

function try_add_required_permission_diffusion_models_rent_view(feature: string, permitted_features: string[]) {
  if (permitted_features.includes(ENUM__workspace_entity_feature.DIFFUSION_MODELS_RESERVATION_VIEW)) return permitted_features; //already added
  if (feature != ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE && feature != ENUM__workspace_entity_feature.DIFFUSION_MODELS_RESERVATION_UPDATE)
    return permitted_features; // no need to add
  if (feature == ENUM__workspace_entity_feature.DIFFUSION_MODELS_RESERVATION_VIEW) return permitted_features; //adding now

  return [...permitted_features, ENUM__workspace_entity_feature.DIFFUSION_MODELS_RESERVATION_VIEW];
}

/*
 * TRY DELETE INHERITED PERMISSIONS
 */
export function try_delete_inherited_permissions(feature: string, permitted_features: string[]) {
  permitted_features = try_delete_inherited_permissions_from_collection_view(feature, permitted_features);
  permitted_features = try_delete_inherited_permissions_from_user_task_view(feature, permitted_features);
  permitted_features = try_delete_inherited_permissions_from_search_view(feature, permitted_features);
  permitted_features = try_delete_inherited_permissions_from_diffusion_models_reservation_view(feature, permitted_features);

  return permitted_features;
}

function try_delete_inherited_permissions_from_collection_view(feature: string, permitted_features: string[]) {
  if (feature != ENUM__workspace_entity_feature.ENTITY_COLLECTION_VIEW) return permitted_features;

  return permitted_features.filter(item => !item.includes(EFeaturesCategory.COLLECTION));
}

function try_delete_inherited_permissions_from_user_task_view(feature: string, permitted_features: string[]) {
  if (feature != ENUM__workspace_entity_feature.ENTITY_USER_TASK_VIEW) return permitted_features;

  return permitted_features.filter(item => !item.includes(EFeaturesCategory.USER_TASK) && !item.includes(EFeaturesCategory.GENERATION));
}

function try_delete_inherited_permissions_from_search_view(feature: string, permitted_features: string[]) {
  if (feature != ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW) return permitted_features;

  return permitted_features.filter(item => !item.includes(EFeaturesCategory.SEARCH));
}

function try_delete_inherited_permissions_from_diffusion_models_reservation_view(feature: string, permitted_features: string[]) {
  if (feature != ENUM__workspace_entity_feature.DIFFUSION_MODELS_RESERVATION_VIEW) return permitted_features;

  return permitted_features
    .filter(item => item != ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)
    .filter(item => item != ENUM__workspace_entity_feature.DIFFUSION_MODELS_RESERVATION_UPDATE);
}
